import React from 'react';
import { Avatar } from '@shopify/polaris';
import { getInitials } from 'utils/strings';

export default function AvatarInitials({ firstName, lastName, ...props }) {
  return <Avatar initials={getInitials(firstName, lastName)} {...props} />;
}
